<template>
  <div>
    <h5 class="mb-3 font-weight-bold">Export Split By (Required)</h5>

    <GroupedOptions
        v-model="innerValue"
        :options="splitByOptions"
        button-classes="badge badge-pill mr-2 mb-2 text-capitalize"
        name="export_by"
    />
  </div>
</template>

<script>
import { defineComponent, computed, watch, ref } from '@vue/composition-api'

import { splitByOptions } from './../utils'
import GroupedOptions from '@components/GroupedOptions'

export default defineComponent({
  name: 'SaveReportWizardSplitBy',
  components: {
    GroupedOptions
  },
  emits: ['input'],
  props: {
    value: String,
    exportType: String
  },
  setup(props, { emit }) {
    const MARKET_DEFAULT = 'umr-risk_code-lloyds_cat_code-section_no-settlement_currency-year_of_account'
    const innerValue = computed({
      get: () => {
        return props.value
      },
      set: (newValue) => emit('input', newValue)
    })

    watch([() => props.exportType, () => props.value],
        ([newExportType, newValue]) => {

          if (newExportType === 'market_export') {
            // Force default split when switching to market export
            if (newValue !== MARKET_DEFAULT) {
              emit('input', MARKET_DEFAULT)
            }
          } else {
            // If not market export and user still has default split, clear it
            if (newValue === MARKET_DEFAULT) {
              emit('input', '')
            }
          }

          // Detect user choosing a custom option while in market export
          if (newExportType === 'market_export' && newValue !== MARKET_DEFAULT) {
            emit('set-export-type', 'custom_export')
          }
        },
        { immediate: true }
    )

    return {
      innerValue,
      splitByOptions
    }
  }
})
</script>
